import * as React from 'react';
import classnames from 'classnames';
import Icon from './assets/bond-wellness.inline.svg';
import * as styles from './Circle.module.scss';

type CircleProps = {
    isSelected?: boolean;
};

export default function Circle({ isSelected }: CircleProps) {
    return (
        <span
            className={classnames(styles.root, {
                [styles.selected]: isSelected,
            })}
        >
            <Icon />
        </span>
    );
}
